import { useContext, useEffect, useState } from "react";

import ColllectionContext from "modules/Collection/context";

import Collection from "./Item";
import { ButtonLoadMore, ContainerList } from "./styles";

type CollectionsProps = {
  filter: any;
  classItem: string;
  newCollection?: any;
};

const Collections = ({
  filter,
  classItem,
  newCollection,
}: CollectionsProps) => {
  const { collections, collectionsMeta, loadMoreCollections } =
    useContext(ColllectionContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [sortedCollections, setSortedCollections] = useState([]);

  const handleLoadMoreCollections = () => {
    loadMoreCollections(currentPage + 1);
    setCurrentPage(currentPage + 1);
  };

  useEffect(() => {
    if (collections?.length) {
      const collectionsWithNoLastAccess = collections?.filter(
        (collection) => !collection?.last_access,
      );
      const collectionsWithLastAccess = collections?.filter(
        (collection) => collection?.last_access,
      );

      const collectionsList = collectionsWithLastAccess?.sort((a, b) => {
        const lastAccessA = new Date(a?.last_access);
        const lastAccessB = new Date(b?.last_access);

        return lastAccessA.getTime() - lastAccessB.getTime();
      });

      if (collectionsList.lenght && collectionsWithNoLastAccess.length) {
        setSortedCollections([
          ...collectionsList,
          ...collectionsWithNoLastAccess,
        ]);
      } else {
        setSortedCollections(collections);
      }
    }
  }, [collections]);

  return (
    <>
      <ContainerList
        itemLayout="horizontal"
        dataSource={sortedCollections?.filter(
          (coll) =>
            coll?.name?.toLowerCase().indexOf(filter?.toLowerCase()) !== -1,
        )}
        renderItem={(item) => (
          <Collection
            item={item}
            classItem={classItem}
            newCollection={newCollection}
          />
        )}
      />

      {collectionsMeta?.last_page > currentPage && (
        <ButtonLoadMore onLoad={handleLoadMoreCollections} />
      )}
    </>
  );
};

export default Collections;
